import {MassUpdatesPage} from './components';

export default MassUpdatesPage;
